<div class="bg-primary" id="layoutAuthentication">
    <div class="d-flex justify-content-center align-items-center" id="layoutAuthentication_content">
        <main><ng-content></ng-content></main>
    </div>
    <div id="layoutAuthentication_footer"><sb-footer [dark]="true"></sb-footer></div>
</div>
